// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__12TiJ","header":"PatientQuestionnaire_header__3e3C1","info":"PatientQuestionnaire_info__2yL2V"};